import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AnimatedDashboard } from '../../../components/animation/AnimatedDashboard';
import { H3, P3 } from '../../../styles/FontStyles';
import { Flexed, SectionSeparator } from '../../../styles/GlobalComponents';
import { colors } from '../../../styles/GlobalStyles';
import { getEntryPackages } from '../Marketplace.actions';
import { formatUSDNoDecimals } from '../../../helpers/helperFunctions';
import { EntryPackagesGrid, GridItem } from './EntryPackage.styled';
import { Button } from '../../../components/common/Button/Button';
import Spinner from '../../../components/common/Spinner';
import { Icon } from '../../../styles/Icons';
import basic from '../../../assets/images/backoffice/entryPackages/basic.jpg';
import builder from '../../../assets/images/backoffice/entryPackages/builder.jpg';
import elite from '../../../assets/images/backoffice/entryPackages/elite.jpg';
import pro from '../../../assets/images/backoffice/entryPackages/pro.jpg';
import ultimate from '../../../assets/images/backoffice/entryPackages/ultimate.jpg';
import { PurchasePackageAndCombo } from '../PurchasePackageAndCombo/PurchasePackageAndCombo';
import { SETTINGS_VIRTUAL_OFFICE } from '../../../routes/routes';
import { useHistory } from 'react-router';

export const EntryPackages = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { loading, hubs } = useSelector((state) => state.marketplace);
  const [selectedHub, setSelectedHub] = useState(hubs?.[0] || null);
  const [modal, setModal] = useState(false);

  useEffect(() => {
    dispatch(getEntryPackages());
  }, [dispatch]);

  const handleSeeDetails = (hub) => {
    setSelectedHub(hub);
  };

  const handleSelectPackage = (hub) => {
    setModal(true);
    handleSeeDetails(hub);
  };

  if (loading) return <Spinner fullScreen={true} />;

  return (
    <AnimatedDashboard zoom dark key={'marketplace'}>
      <H3 color={colors.neutral900} mb='22'>
        Choose your Entry Package
      </H3>

      <EntryPackagesGrid>
        {hubs?.map((hub, index) => (
          <GridItem
            image={hub?.imageUrl}
            key={index}
            selected={selectedHub?.id === hub?.id}>
            <div>
              <Flexed column center>
                <H3 color={colors.neutral0} mb='50' mt='20'>
                  {hub?.name}
                </H3>
              </Flexed>

              <Flexed height='200px'>
                <div>
                  <Flexed center between gap='10px' mb='12'>
                    <Flexed center gap='5px'>
                      <Icon color={colors.lightGreen}>
                        <svg
                          width='16'
                          height='15'
                          viewBox='0 0 16 15'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'>
                          <path
                            d='M8.07812 1.40625C4.71807 1.40625 1.98438 4.13994 1.98438 7.5C1.98438 10.8601 4.71807 13.5937 8.07812 13.5937C11.4382 13.5937 14.1719 10.8601 14.1719 7.5C14.1719 4.13994 11.4382 1.40625 8.07812 1.40625ZM11.2495 5.45771L7.31201 10.1452C7.26882 10.1967 7.21508 10.2382 7.15442 10.2671C7.09376 10.2959 7.02761 10.3114 6.96045 10.3125H6.95254C6.88684 10.3125 6.82187 10.2986 6.76186 10.2719C6.70185 10.2451 6.64814 10.2061 6.6042 10.1572L4.9167 8.28223C4.87384 8.23677 4.8405 8.18321 4.81864 8.12468C4.79678 8.06616 4.78684 8.00386 4.78941 7.94144C4.79197 7.87902 4.80698 7.81774 4.83356 7.7612C4.86015 7.70467 4.89776 7.65402 4.9442 7.61223C4.99064 7.57044 5.04496 7.53835 5.10398 7.51786C5.16299 7.49736 5.22551 7.48887 5.28785 7.49288C5.35019 7.49689 5.41111 7.51332 5.46701 7.54121C5.52291 7.5691 5.57268 7.60788 5.61338 7.65527L6.94023 9.12949L10.5317 4.85479C10.6123 4.76164 10.7263 4.70395 10.849 4.69416C10.9718 4.68438 11.0935 4.7233 11.1878 4.80251C11.2821 4.88172 11.3414 4.99485 11.353 5.11745C11.3645 5.24006 11.3273 5.36229 11.2495 5.45771Z'
                            fill='#53C0F2'
                          />
                        </svg>
                      </Icon>
                      <P3 left color={colors.neutral0}>
                        {hub?.details?.items?.backofficeLicence?.name}
                      </P3>
                    </Flexed>
                    <P3 left color={colors.neutral0}>
                      $
                      {formatUSDNoDecimals(
                        hub?.details?.items?.backofficeLicence?.price
                      )}
                    </P3>
                  </Flexed>
                  <Flexed center between gap='10px' mb='12'>
                    <Flexed center gap='5px'>
                      <Icon color={colors.lightGreen}>
                        <svg
                          width='16'
                          height='15'
                          viewBox='0 0 16 15'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'>
                          <path
                            d='M8.07812 1.40625C4.71807 1.40625 1.98438 4.13994 1.98438 7.5C1.98438 10.8601 4.71807 13.5937 8.07812 13.5937C11.4382 13.5937 14.1719 10.8601 14.1719 7.5C14.1719 4.13994 11.4382 1.40625 8.07812 1.40625ZM11.2495 5.45771L7.31201 10.1452C7.26882 10.1967 7.21508 10.2382 7.15442 10.2671C7.09376 10.2959 7.02761 10.3114 6.96045 10.3125H6.95254C6.88684 10.3125 6.82187 10.2986 6.76186 10.2719C6.70185 10.2451 6.64814 10.2061 6.6042 10.1572L4.9167 8.28223C4.87384 8.23677 4.8405 8.18321 4.81864 8.12468C4.79678 8.06616 4.78684 8.00386 4.78941 7.94144C4.79197 7.87902 4.80698 7.81774 4.83356 7.7612C4.86015 7.70467 4.89776 7.65402 4.9442 7.61223C4.99064 7.57044 5.04496 7.53835 5.10398 7.51786C5.16299 7.49736 5.22551 7.48887 5.28785 7.49288C5.35019 7.49689 5.41111 7.51332 5.46701 7.54121C5.52291 7.5691 5.57268 7.60788 5.61338 7.65527L6.94023 9.12949L10.5317 4.85479C10.6123 4.76164 10.7263 4.70395 10.849 4.69416C10.9718 4.68438 11.0935 4.7233 11.1878 4.80251C11.2821 4.88172 11.3414 4.99485 11.353 5.11745C11.3645 5.24006 11.3273 5.36229 11.2495 5.45771Z'
                            fill='#53C0F2'
                          />
                        </svg>
                      </Icon>
                      <P3 left color={colors.neutral0}>
                        {hub?.details?.items?.kryptoTapCard?.name}
                      </P3>
                    </Flexed>
                    <P3 left color={colors.neutral0}>
                      $
                      {formatUSDNoDecimals(
                        hub?.details?.items?.kryptoTapCard?.price
                      )}
                    </P3>
                  </Flexed>
                  <Flexed center between gap='10px' mb='12'>
                    <Flexed center gap='5px'>
                      <Icon color={colors.lightGreen}>
                        <svg
                          width='16'
                          height='15'
                          viewBox='0 0 16 15'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'>
                          <path
                            d='M8.07812 1.40625C4.71807 1.40625 1.98438 4.13994 1.98438 7.5C1.98438 10.8601 4.71807 13.5937 8.07812 13.5937C11.4382 13.5937 14.1719 10.8601 14.1719 7.5C14.1719 4.13994 11.4382 1.40625 8.07812 1.40625ZM11.2495 5.45771L7.31201 10.1452C7.26882 10.1967 7.21508 10.2382 7.15442 10.2671C7.09376 10.2959 7.02761 10.3114 6.96045 10.3125H6.95254C6.88684 10.3125 6.82187 10.2986 6.76186 10.2719C6.70185 10.2451 6.64814 10.2061 6.6042 10.1572L4.9167 8.28223C4.87384 8.23677 4.8405 8.18321 4.81864 8.12468C4.79678 8.06616 4.78684 8.00386 4.78941 7.94144C4.79197 7.87902 4.80698 7.81774 4.83356 7.7612C4.86015 7.70467 4.89776 7.65402 4.9442 7.61223C4.99064 7.57044 5.04496 7.53835 5.10398 7.51786C5.16299 7.49736 5.22551 7.48887 5.28785 7.49288C5.35019 7.49689 5.41111 7.51332 5.46701 7.54121C5.52291 7.5691 5.57268 7.60788 5.61338 7.65527L6.94023 9.12949L10.5317 4.85479C10.6123 4.76164 10.7263 4.70395 10.849 4.69416C10.9718 4.68438 11.0935 4.7233 11.1878 4.80251C11.2821 4.88172 11.3414 4.99485 11.353 5.11745C11.3645 5.24006 11.3273 5.36229 11.2495 5.45771Z'
                            fill='#53C0F2'
                          />
                        </svg>
                      </Icon>
                      <P3 left color={colors.neutral0}>
                        {hub?.details?.items?.node?.name}
                      </P3>
                    </Flexed>
                    <P3 left color={colors.neutral0}>
                      ${formatUSDNoDecimals(hub?.details?.items?.node?.price)}
                    </P3>
                  </Flexed>
                  {hub?.details?.items?.x1Node && (
                    <Flexed center between gap='10px' mb='12'>
                      <Flexed center gap='5px'>
                        <Icon color={colors.lightGreen}>
                          <svg
                            width='16'
                            height='15'
                            viewBox='0 0 16 15'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'>
                            <path
                              d='M8.07812 1.40625C4.71807 1.40625 1.98438 4.13994 1.98438 7.5C1.98438 10.8601 4.71807 13.5937 8.07812 13.5937C11.4382 13.5937 14.1719 10.8601 14.1719 7.5C14.1719 4.13994 11.4382 1.40625 8.07812 1.40625ZM11.2495 5.45771L7.31201 10.1452C7.26882 10.1967 7.21508 10.2382 7.15442 10.2671C7.09376 10.2959 7.02761 10.3114 6.96045 10.3125H6.95254C6.88684 10.3125 6.82187 10.2986 6.76186 10.2719C6.70185 10.2451 6.64814 10.2061 6.6042 10.1572L4.9167 8.28223C4.87384 8.23677 4.8405 8.18321 4.81864 8.12468C4.79678 8.06616 4.78684 8.00386 4.78941 7.94144C4.79197 7.87902 4.80698 7.81774 4.83356 7.7612C4.86015 7.70467 4.89776 7.65402 4.9442 7.61223C4.99064 7.57044 5.04496 7.53835 5.10398 7.51786C5.16299 7.49736 5.22551 7.48887 5.28785 7.49288C5.35019 7.49689 5.41111 7.51332 5.46701 7.54121C5.52291 7.5691 5.57268 7.60788 5.61338 7.65527L6.94023 9.12949L10.5317 4.85479C10.6123 4.76164 10.7263 4.70395 10.849 4.69416C10.9718 4.68438 11.0935 4.7233 11.1878 4.80251C11.2821 4.88172 11.3414 4.99485 11.353 5.11745C11.3645 5.24006 11.3273 5.36229 11.2495 5.45771Z'
                              fill='#53C0F2'
                            />
                          </svg>
                        </Icon>
                        <P3 left color={colors.neutral0}>
                          {hub?.details?.items?.x1Node?.name}
                        </P3>
                      </Flexed>
                      <P3 left color={colors.neutral0}>
                        $
                        {formatUSDNoDecimals(
                          hub?.details?.items?.x1Node?.price
                        )}
                      </P3>
                    </Flexed>
                  )}
                </div>
              </Flexed>
            </div>
            <Flexed center between gap='10px' mb='0' mt='30'>
              <P3 left color={colors.neutral0} bold>
                Valued at:
              </P3>
              <P3 left color={colors.neutral0} bold>
                ${formatUSDNoDecimals(hub?.details?.oldPrice)}
              </P3>
            </Flexed>
            <SectionSeparator margin='8px 0' />
            <Flexed center between gap='10px' mb='8'>
              <P3 left color={colors.primary900} bold>
                Pack Price:
              </P3>
              <P3 left color={colors.primary900} bold>
                ${formatUSDNoDecimals(hub?.price)}
              </P3>
            </Flexed>
            <Flexed center between gap='10px' mb='8'>
              <P3 left color={colors.neutral0} bold>
                CV:
              </P3>
              <P3 left color={colors.neutral0} bold>
                ${formatUSDNoDecimals(hub?.details?.cv)}
              </P3>
            </Flexed>
            <Button
              mt='15'
              w='100%'
              wSM='100%'
              onClick={() => handleSelectPackage(hub)}>
              Get {hub?.name}
            </Button>
          </GridItem>
        ))}
      </EntryPackagesGrid>
      {/* <Flexed center justifyCenter mt='40'>
        <Button
          negative
          w='500px'
          wSM='100%'
          onClick={() => history.push(SETTINGS_VIRTUAL_OFFICE)}>
          I only want Back Office Subscription
        </Button>
      </Flexed> */}

      <PurchasePackageAndCombo
        selectedPackage={selectedHub}
        modal={modal}
        setModal={setModal}
      />
    </AnimatedDashboard>
  );
};
